import getApiClient from '@/plugins/api-client'
import {accentInsensitiveFilter, highlightParts} from '@/helpers/textNormalizerHelper'

export default {
    searchProfessionals: function(append = false) {
        const self = this,
            api = getApiClient(self.$store)

        if (! append) {
            self.resetProfessionalsList()
        }

        if (self.citySearchInput && !self.filters['user.address.city']) {
            self.filters['user.address.city'] = self.citySearchInput.trim()
        }

        if (self.filters['user.address.city'] === '' || self.filters['user.address.city'] === null) {
            delete self.filters['user.address.city']
        }

        let ignoredUsers = []
        if (self.$route.params.ignoreUser) {
            ignoredUsers.push(self.$route.params.ignoreUser)
        }

        if (self.alreadySelectedUsers) {
            ignoredUsers.push(...self.alreadySelectedUsers)
        }

        if (ignoredUsers.length) {
            self.filters['user.id[not]'] = ignoredUsers.join(',')
        }
        self.filters['fees.type'] = self.$store.state.profileFinder.query.type

        if (self.$store.state.profileFinder.query.latitude && self.$store.state.profileFinder.query.longitude) {
            self.filters.coordinates = `${self.$store.state.profileFinder.query.latitude},${self.$store.state.profileFinder.query.longitude}`
        }

        if (self.filters['user.name'] === '') {
            delete self.filters['user.name']
        }

        let filters = {...self.filters}

        if (this.filterVaccinationCertificate) {
            filters['exists[user.vaccinationCertificate]'] = true
        }

        if (this.filters['user.phone']) {
            filters['user.phone'] = self.filters['user.phone'].replace(/[^0-9]/g, '')
        }

        if (!filters['user.symplaParticipations.event.id']?.length) {
            filters['user.symplaParticipations.profiles'] = null
            this.$store.commit('updateProfileSearchSymplaEventsUsed', [])
        } else {
            filters['user.symplaParticipations.percentCompleted'] = 100;
            filters['user.symplaParticipations.profiles'] = self.$store.state.profileFinder.query.category
            this.$store.commit('updateProfileSearchSymplaEventsUsed', filters['user.symplaParticipations.event.id'])
        }

        this.$store.commit('setProfileSearchFilters', self.filters)

        api.get(`/work_profiles`, {
            params: {
                ... filters,
                event: self.$store.state.profileFinder.query.eventId,
                page: self.profileFinder.page,
                category: self.$store.state.profileFinder.query.category,
                types: self.$store.state.profileFinder.query.type,
                quantity: self.$store.state.profileFinder.query.quantity
            }
        })
            .then(result => {
                if (! result.data['hydra:totalItems']) {
                    self.showNoProfilesFound = true
                } else {
                    self.showNoProfilesFound = false
                }

                let data = result.data['hydra:member']
                self.$store.commit('pushProfileFinderResult', data)

                self.$store.commit('profileFinderReachedEnd', false)
                if (! data.length) {
                    self.$store.commit('profileFinderReachedEnd', true)
                }
            })
            .catch(error => {
                console.log(error)
            })
    },

    loadNextPage: function() {
        const self = this

        self.$store.commit('profileFinderNextPage')
        self.filters.page++

        self.searchProfessionals(true)
    },

    resetProfessionalsList: function() {
        const self = this

        self.$store.commit('resetProfileFinderResult')
    },

    backToEvent: function() {
        const self = this,
            isReplaceAction = self.$route.params.replaceJob

        if (isReplaceAction) {
            self.$router.push({
                name: 'EventDetails',
                hash: '#select-professional',
                params: {
                    id: self.$store.state.profileFinder.query.eventId
                }
            })
            return
        }

        self.$router.push({
            name: 'ContractorEventForm',
            hash: '#select-professional',
            params: {
                id: self.$store.state.profileFinder.query.eventId
            }
        })
    },

    removeProfile: function(profileIndex) {
        const self = this,
            profileFinder = self.$store.state.profileFinder,
            removedProfile = profileFinder.profiles[profileIndex]

        if (removedProfile && removedProfile['@id']) {
            self.deleteDraftSelection(removedProfile['@id'])
        }

        self.$store.commit('setProfileSearchProfile', {
            index: profileIndex,
            profile: {}
        })

        self.$store.commit('setProfileSearchIndex', profileIndex)
        self.$parent.forceRerender()
        self.currentIndex = profileIndex
    },

    deleteDraftSelection: function(workProfileIri) {
        const self = this,
            api = getApiClient(self.$store),
            profileFinder = self.$store.state.profileFinder,
            eventId = profileFinder.query.eventId,
            profileSearchId = profileFinder.profileSearchId,
            eventStatus = profileFinder.event ? profileFinder.event.status : null

        if (!eventId || !profileSearchId || !workProfileIri || eventStatus !== 'creating') {
            return
        }

        // Note: the backend does not expose a `workProfile.id` filter for this
        // resource, so filtering has to happen client-side. Relying on the API
        // to filter by workProfile would silently return (and delete) every
        // draft selection for this profileSearch, wiping out the other already
        // selected professionals whenever quantity > 1.
        api.get('/draft_job_selections', {
            params: {
                'event.id': eventId,
                'profileSearch.id': profileSearchId,
                pagination: false
            }
        }).then(result => {
            const drafts = result.data['hydra:member'] || []
            drafts.filter(draft => {
                const draftWorkProfileIri = draft.workProfile && typeof draft.workProfile === 'object'
                    ? draft.workProfile['@id']
                    : draft.workProfile

                return draftWorkProfileIri === workProfileIri
            }).forEach(draft => {
                api.delete(draft['@id']).catch(error => {
                    console.log('Failed to delete draft selection:', error)
                })
            })
        }).catch(error => {
            console.log('Failed to find draft selection for deletion:', error)
        })
    },

    openProfileDetails: function(profileId) {
        const self = this

        const profileRoute = self.$route.params.replaceJob ? 'ProfessionalReplaceProfile' : 'ProfessionalFinderProfile';

        self.$router.push({
            name: profileRoute,
            params: {
                id: profileId,
                replaceJob: self.$route.params.replaceJob
            }
        })
    },

    selectProfile: function(profile) {
        const self = this,
            profileFinderData = self.$store.state.profileFinder,
            currentIndex = profileFinderData.currentIndex,
            existingProfile = profileFinderData.profiles[currentIndex]

        if (existingProfile && existingProfile['@id']) {
            self.deleteDraftSelection(existingProfile['@id'])
        }

        self.$store.commit('setProfileSearchProfile', {
            index: currentIndex,
            profile: profile,
            symplaEventsUsed: self.$store.state.profileSearchSymplaEventsUsed
        })
        self.$store.commit('increaseProfileSearchIndex')

        if (profileFinderData.currentIndex >= profileFinderData.query.quantity) {
            self.$store.commit('setProfileSearchIndex', profileFinderData.query.quantity - 1)
        }

        self.saveDraftSelection(profile, profileFinderData, currentIndex)
        self.$parent.forceRerender()
    },

    saveDraftSelection: function(profile, profileFinderData, slotIndex) {
        const self = this,
            api = getApiClient(self.$store),
            eventId = profileFinderData.query.eventId,
            profileSearchId = profileFinderData.profileSearchId,
            eventStatus = profileFinderData.event ? profileFinderData.event.status : null

        if (!eventId || !profileSearchId || !profile || !profile['@id']) {
            return
        }

        if (eventStatus !== 'creating') {
            return
        }

        api.post('/draft_job_selections', {
            event: `/events/${eventId}`,
            profileSearch: `/profile_searches/${profileSearchId}`,
            workProfile: profile['@id'],
            slotIndex
        }).catch(error => {
            console.log('Failed to save draft selection:', error)
        })
    },

    setProfiles: function(searchId) {
        const self = this,
            profiles = self.profileFinder.profiles,
            replaceJob = self.$route.params.replaceJob,
            api = getApiClient(self.$store)

        self.$store.commit('setProfiles', {
            id: searchId,
            type: self.$store.state.profileFinder.query.type,
            profiles
        })

        if (replaceJob && profiles[0].id) {
            api.get(`jobs/${replaceJob}`)
                .then(result => {
                    api.patch(`jobs/${replaceJob}/cancel`, {
                        status: result.data.status === 1 ? 7 : 3
                    }, {
                        headers: {
                            'Content-Type': 'application/merge-patch+json'
                        }
                    })
                        .then(() => {
                            api.post(`jobs/replace`, {
                                job: `/jobs/${replaceJob}`,
                                workProfile: `work_profiles/${profiles[0].id}`
                            })
                                .then(() => {
                                    self.$store.commit('resetProfileSearches')
                                    self.backToEvent()
                                })
                                .catch(error => {
                                    console.log(error)
                                })
                                .finally(() => {
                                    self.$root.$emit('reloadDeniedJobs')
                                })

                        })
                        .catch(error => {
                            console.log(error)
                        })
                })
                .catch(error => {
                    console.log(error)
                })

            return
        }

        self.backToEvent()
    },

    profileIsSelected: function(id) {
        const self = this

        return self.profileFinder.profiles.filter(profile => {
            return profile && profile.id === id
        }).length > 0
    },

    getProfileCategoryLabel(category) {
        let item = this.availableJobCategories.filter(item => {
            return item.code === category
        })

        return item[0]?.label ?? category
    },

    toggleFavorite(id) {
        const self = this,
            api = getApiClient(self.$store)

        let favorites = self.$store.state.session.favoriteWorkProfiles,
            favoriteIds = favorites.map(profile => {
                return profile['@id']
            })

        if (!favoriteIds.includes(id)) {
            favoriteIds.push(id)
        } else {
            favoriteIds = favoriteIds.filter(profileId => {
                return profileId !== id
            })
        }

        api.patch(`/contractor/favorite_workprofiles/${self.$store.state.session.user.id}`, {favoriteWorkProfiles: favoriteIds}, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.$store.commit('setFavoriteWorkProfiles', result.data.favoriteWorkProfiles['hydra:member'])
                console.log(result.data)
            })
            .catch(error => {
                console.log(error)
            })
    },

    toggleVaccinationCertificateFilter() {
        this.filterVaccinationCertificate = !this.filterVaccinationCertificate
        this.searchProfessionals(false)
    },

    toggleFavoritesFirst() {
        this.filters.favoritesFirst = !this.filters.favoritesFirst
        this.searchProfessionals(false)
    },

    changeProfileFinderIndex(index) {
        if (!this.profileFinder.profiles[index].id) {
            this.$store.commit('setProfileSearchIndex', index)
        }
    },

    loadSymplaEvents() {
        const self = this

        if (self.symplaEvents.length) {
            return
        }

        const api = getApiClient(self.$store)

        api.get('sympla_events/list')
            .then(result => {
                self.symplaEvents = result.data['hydra:member']
                self.showSymplaEvents = true
                self.$store.commit('setSymplaEvents', self.symplaEvents)
            })
            .catch(error => {
                console.log(error)
            })
    },

    onNameFilterInput() {
        const self = this,
            name = self.filters['user.name'] ?? ''

        clearTimeout(self.nameFilterDebounceTimeout)

        if (name.length > 0 && name.length < 3) {
            return
        }

        self.nameFilterDebounceTimeout = setTimeout(() => {
            self.searchProfessionals(false)
        }, 300)
    },

    cityFilter: accentInsensitiveFilter,

    cityHighlight: highlightParts,

    onCitySearchInput(term) {
        const self = this,
            search = (term ?? '').trim()

        self.citySearchInput = term
        clearTimeout(self.cityDebounceTimeout)

        if (!search) {
            self.cityRequestId++
            self.availableCities = []
            self.loadingCities = false
            return
        }

        if (search === self.filters['user.address.city']) {
            return
        }

        self.cityDebounceTimeout = setTimeout(() => {
            self.loadAvailableCities(search)
        }, 300)
    },

    loadAvailableCities(search) {
        const self = this,
            api = getApiClient(self.$store),
            requestId = ++self.cityRequestId

        self.loadingCities = true

        api.get('/professionals/cities', {params: {search}})
            .then(result => {
                if (requestId === self.cityRequestId) {
                    self.availableCities = result.data || []
                }
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                if (requestId === self.cityRequestId) {
                    self.loadingCities = false
                }
            })
    }
}
